module.exports = __webpack_public_path__ + "static/md-d09118bed729a0767548a68afc7e6d81.svg";